// This component is only rendered for PRO or CA package
import React, { useContext } from 'react';
import MembershipFlowContext from '../../context/membership_flow_context';
import pickBy from 'lodash/pickBy';
import classNames from 'classnames';
import { createQueryString } from '../../../utilities/utilities';
import {
  PRO_PACKAGE_SHORT_NAME
} from '../../constants/membership_flow.constants';
// eslint-disable-next-line
import TermsAndConditions from '../../../components/react/terms_and_conditions/terms_and_conditions';

const UPGRADE_PATH = '/upgrade/payment';

const GetStarted = () => {
  const { packageShortName, paymentPage, returnTo, text1, text2 } = useContext(
    MembershipFlowContext
  );

  const upgradePath =
    UPGRADE_PATH +
    createQueryString(
      pickBy({
        package_short_name: packageShortName,
        payment_page_permalink: paymentPage,
        return_to: returnTo,
      })
    );

  /**
   * @type {Node}
   */
  const additionalProMention = (
    <ul
      data-testid='pro-devex-newswire-disclaimer'
      className='list-arrows text-gray-li animate-item animate-order-6 small-text'
    >
      <li>
        You will automatically receive the Devex Newswire daily and our weekly newsletter
        exclusively for Devex Pro members.
      </li>
      <li>Your subscription will renew automatically and you can cancel at any time.</li>
    </ul>
  );

  return (
    <div
      data-testid='get-started'
      className='get-started d-flex flex-column justify-content-end align-self-center animate-item animate-order-1'
    >
      {text1 && (
        <div className={classNames('animate-item animate-order-2 mt-3 text-1', { 'mb-5': !text2 })}>
          {text1}
        </div>
      )}
      {text2 && <div className='mb-5 animate-item animate-order-3 text-2'>{text2}</div>}
      <a
        href={upgradePath}
        className='btn btn-solid btn-dark btn-lg w-100 animate-item animate-order-4'
      >
        <strong className='text-white'>Get started</strong>
      </a>
      <div className='mt-5 mb-3 animate-item animate-order-5'>
        <TermsAndConditions />
      </div>
      {packageShortName === PRO_PACKAGE_SHORT_NAME && additionalProMention}
      <div className='mt-1 text-gray-li animate-item animate-order-7 small-text'>
        Questions?{' '}
        <a
          href='https://support.devex.com/'
          className='link-blue-orange'
          target='_blank'
          rel='noreferrer'
        >
          Contact our member support team
        </a>
        .
      </div>
    </div>
  );
};

export default GetStarted;
